
import { Typography } from "@mui/material";
import FetchHQLocationDashBoardModal from "./modals/FetchHQLocationDashBoardModal";
import { useEffect, useState } from "react";
import { UserHQLocationDashBoardStore } from "../../../../store/main/UserHQLocationDashBoardStore";
import CreateUpdateHQLocationDashBoardModal from "./modals/CreateUpdateHQLocationDashBoardModal";

type FetchUserHQLocationDashBoardType = {
  success: boolean;
  headquarter_location: HeadquarterLocation | null;
};

type HeadquarterLocation = {
  id: number; 
  user_id: number; 
  latlong: string; 
  location_metadata: LocationMetadata; 
  month_year: number; 
  status: string; 
};

type LocationMetadata = {
  status: string;
  results: LocationResult[]; 
};

type LocationResult = {
  types: string[]; 
  placeID: string; 
  geometry: Geometry; 
  plusCode: PlusCode; 
  formattedAddress: string; 
  addressComponents: AddressComponent[];
};

type Geometry = {
  location: Coordinates; 
  viewport: Viewport; 
  locationType: string; 
};

type Coordinates = {
  lat: number; 
  lng: number;
};

type Viewport = {
  northeast: Coordinates; 
  southwest: Coordinates;
};

type PlusCode = {
  globalCode: string; 
  compoundCode: string; 
};

type AddressComponent = {
  types: string[]; 
  longName: string; 
  shortName: string; 
};


const UserHQLocationDashBoardDesktop =() => {
  const [fetchLat, setFetchLat] = useState<number | null>(null);
  const [fetchLong, setFetchLong] = useState<number | null>(null);
  const [fetchHQLocation, setFetchHQLocation] =
    useState<HeadquarterLocation | null>(null);
  const [open, setOpen] = useState<boolean>(true); 
  const [locationMetaData, setLocationMetaData] =
    useState<LocationMetadata | null>(null);
      const [openCreateModal, setOpenCreateModal] = useState(false);

  const {
    fetchUserHQLocationDashBoard,
    UserHQLocationDashBoardState,
    UserHQLocationDashBoard,
  } = UserHQLocationDashBoardStore();

  useEffect(() => {
    fetchApiUserHQLocation();
  }, []);

  const fetchApiUserHQLocation = async () => {
    const fetchAPIHqLocationResponse = await fetchUserHQLocationDashBoard();
    if (fetchAPIHqLocationResponse?.success) {
      setFetchHQLocation(fetchAPIHqLocationResponse?.headquarter_location);
      setLocationMetaData(
        fetchAPIHqLocationResponse?.headquarter_location?.location_metadata
      );
      const latLongString =
        fetchAPIHqLocationResponse?.headquarter_location?.latlong;
      if (latLongString) {
        const [lat, long] = latLongString.split(",").map(Number);
        setFetchLat(lat);
        setFetchLong(long);
        
      }
       // ⭐ CASE-2 → latlng missing → Open map modal
      if (!latLongString) {
        setOpenCreateModal(true);
      }
    }
  };
  const latlng = fetchHQLocation?.latlong; 

  let ModalComponent = null;
  // if (!fetchHQLocation || !latlng) {
    // Case 2: If headquarter_location is null, open CreateUpdateHQLocationDashBoardModal

    ModalComponent = (
      <CreateUpdateHQLocationDashBoardModal
        lat={fetchLat}
        long={fetchLong}
        locationMetaData={locationMetaData}
        open={open}
        setOpen={setOpen}
      />
    );
  // }
  //  if (latlng) {
  //    // Case 1 & 3: If latlng is present (initial or updated), open FetchHQLocationDashBoardModal
      
  //   ModalComponent = (
  //     <FetchHQLocationDashBoardModal
  //       lat={fetchLat}
  //       long={fetchLong}
  //       locationMetaData={locationMetaData}
  //       open={open}
  //       setOpen={setOpen}
  //     />
  //   );
  // }

  return (
    <>
      {ModalComponent}
    </>
  );
};

export default UserHQLocationDashBoardDesktop;

